module.exports = {"confirmDelete":"Вы действительно хотите удалить этот cпособ связи?"};